// docs/i18n.md §1: サポートロケールの一覧を単一の設定リストとして持つ。
// 3言語目追加時はこの配列とlocaleNativeNamesの2箇所に1行追加するだけで
// 対応できるようにする(コード中のswitch/if分岐を持たない)。
//
// request.ts(next-intlのgetRequestConfig、cookies()/headers()/DBアクセスを
// 使うサーバー専用コード)とは別ファイルに分離している。クライアント側の
// 言語切り替えメニュー(LocaleSwitcher.tsx)がこの一覧・表示名だけを必要とし、
// request.tsをそのままimportするとサーバー専用の依存(~/lib/auth/session等)が
// クライアントバンドルに引き込まれてしまうため。
export const validLocales = ["ja", "en"] as const;

export type Locale = (typeof validLocales)[number];

export const localeNativeNames: Record<Locale, string> = {
  ja: "日本語",
  en: "English",
};

export function isValidLocale(value: string): value is Locale {
  return (validLocales as readonly string[]).includes(value);
}
